<template>
  <v-app id="ai-bot-response" class="ai-bot-response">
    <!--begin::Dashboard-->
    <div class="card card-custom card-stretch h-auto">
      <!--begin::Header-->
      <div class="card-header border-0 py-5 align-items-center">
        <h3 class="card-title align-items-start flex-column m-0 py-3">
          <span class="card-label font-weight-bolder text-dark"
            >Interviews List</span
          >
        </h3>
        <button
          class="btn btn-light font-weight-bolder text-dark-75 position-relative"
          style="z-index: 10"
          v-b-toggle.filter-collapse
        >
          <v-icon>mdi-tune</v-icon> Filter
        </button>
      </div>
      <!--end::Header-->

      <!-- KPI Section -->
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6">
            <div class="card card-custom bg-primary card-stretch gutter-b">
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <span
                      class="text-white font-weight-bolder font-size-h2 mt-2 d-block"
                    >
                      {{ stats.total_conducted_interviews || 0 }}
                    </span>
                    <span class="text-white font-weight-bold font-size-lg"
                      >Interviews Conducted</span
                    >
                  </div>
                  <div class="symbol symbol-50 symbol-light-white">
                    <span class="symbol-label">
                      <i class="flaticon2-user text-primary font-size-h2"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6">
            <div class="card card-custom bg-success card-stretch gutter-b">
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <span
                      class="text-white font-weight-bolder font-size-h2 mt-2 d-block"
                    >
                      {{ stats.total_completed_interviews || 0 }}
                    </span>
                    <span class="text-white font-weight-bold font-size-lg"
                      >Interviews Completed</span
                    >
                  </div>
                  <div class="symbol symbol-50 symbol-light-white">
                    <span class="symbol-label">
                      <i
                        class="flaticon2-check-mark text-success font-size-h2"
                      ></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6">
            <div class="card card-custom bg-warning card-stretch gutter-b">
              <div class="card-body p-3 pl-7">
                <div class="d-flex align-items-center">
                  <div class="d-flex flex-column flex-grow-1 mr-9">
                    <div
                      class="flex-grow-1 d-flex align-items-center justify-content-between"
                    >
                      <span class="text-white font-weight-bold font-size-lg"
                        >No Shows.</span
                      >
                      <span class="text-white font-weight-bolder d-block">
                        {{ stats.total_no_show_interviews || 0 }}
                      </span>
                    </div>
                    <div
                      class="flex-grow-1 d-flex align-items-center justify-content-between"
                    >
                      <span class="text-white font-weight-medium"
                        >Client no show.</span
                      >
                      <span class="text-white d-block">
                        {{ stats.total_client_no_show_interviews || 0 }}
                      </span>
                    </div>
                    <div
                      class="flex-grow-1 d-flex align-items-center justify-content-between"
                    >
                      <span class="text-white font-size-lg"
                        >Talent no show.</span
                      >
                      <span class="text-white d-block">
                        {{ stats.total_talent_no_show_interviews || 0 }}
                      </span>
                    </div>
                    <div
                      class="flex-grow-1 d-flex align-items-center justify-content-between"
                    >
                      <span class="text-white font-size-lg"
                        >Unknown no show.</span
                      >
                      <span class="text-white d-block">
                        {{ stats.total_unknown_no_show_interviews || 0 }}
                      </span>
                    </div>
                  </div>
                  <div class="symbol symbol-50 symbol-light-white">
                    <span class="symbol-label">
                      <i class="flaticon2-delete text-warning font-size-h2"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <v-tooltip bottom color="#ee2d41">
            <template v-slot:activator="{ on, attrs }">
              <div
                class="col-xl-3 col-lg-6 col-md-6 col-sm-6"
                v-bind="attrs"
                v-on="on"
              >
                <div class="card card-custom bg-danger card-stretch gutter-b">
                  <div class="card-body">
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1">
                        <span
                          class="text-white font-weight-bolder font-size-h2 mt-2 d-block"
                        >
                          {{ stats.total_bot_issues_interviews || 0 }}
                        </span>
                        <span class="text-white font-weight-bold font-size-lg"
                          >Bot Issues</span
                        >
                      </div>
                      <div class="symbol symbol-50 symbol-light-white">
                        <span class="symbol-label">
                          <i
                            class="flaticon2-warning text-danger font-size-h2"
                          ></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <span
              >This indicates the number of scheduled interviews that haven’t
              been updated withing 5 hrs.</span
            >
          </v-tooltip>
        </div>
      </div>
      <!--end::Body-->

      <AIBotResponseFilter @applyFilter="applyFilter" />
      <div class="card-body pt-0 pb-3">
        <div class="tab-content">
          <!--begin::Table-->
          <div
            class="table-responsive mb-0"
            v-if="responses && responses.length && responses.length > 0"
          >
            <table
              class="table table-head-custom table-vertical-center table-head-bg table-borderless"
            >
              <thead>
                <tr class="text-left">
                  <th>Candidate Name</th>
                  <th>Interviewer Name</th>
                  <th>Meeting Date</th>
                  <th>Meeting Time</th>
                  <th>Status</th>
                  <th>Update Date by AI Bot</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="meeting in responses"
                  :key="meeting.id"
                  @click="viewMeeting(meeting)"
                  style="cursor: pointer"
                >
                  <td class="pl-0">
                    <div class="text-dark-75 font-weight-bolder font-size-lg">
                      {{ meeting.candidate_name }}
                    </div>
                  </td>
                  <td>
                    <div class="text-dark-75 font-size-lg">
                      {{ meeting.interviewer_name }}
                    </div>
                  </td>
                  <td>
                    <div class="text-dark-75 font-size-lg">
                      {{ formatDate(meeting.meeting_start_time) }}
                    </div>
                  </td>
                  <td>
                    <div class="text-dark-75 font-size-lg">
                      {{
                        formatTimeRange(
                          meeting.meeting_start_time,
                          meeting.meeting_end_time
                        )
                      }} (UTC)
                    </div>
                  </td>
                  <td>
                    <b-badge
                      class="font-weight-bolder"
                      :variant="getStatusClass(meeting.meeting_status?.id)"
                      >{{ meeting.meeting_status?.name || "-" }}</b-badge
                    >
                  </td>
                  <td>
                    <span class="font-weight-bolder font-size-lg">
                      {{ formatDateTime(meeting.updated_at) }}
                      {{ meeting.updated_at ? "(UTC)" : "" }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <h5
            class="my-5 text-muted text-center"
            v-if="responses && responses.length === 0"
          >
            No Results Found
          </h5>
          <div class="pagination-container">
            <p
              v-if="responses && responses.length > 0"
              class="pagination-container__desc"
            >
              {{
                $t("showing_results", {
                  length: responses.length,
                  total: responsesMeta.total,
                })
              }}
            </p>
            <b-pagination
              v-if="responsesMeta && responsesMeta.last_page > 1"
              v-model="currentPage"
              :total-rows="responsesMeta.total"
              :per-page="responsesMeta.per_page"
              align="center"
              last-number
              first-number
              @change="handlePageChange"
            ></b-pagination>
          </div>
        </div>
      </div>
      <!--end::Body-->
    </div>
    <!--end::Dashboard-->

    <!-- Meeting Details Modal -->
    <b-modal
      v-model="showDetailsModal"
      title="Interview Details"
      size="lg"
      hide-footer
    >
      <div v-if="meetingDetailsLoading" class="meeting-details">
        <div
          class="text-center py-5 d-flex flex-column align-items-center justify-content-center"
          style="min-height: 180px"
        >
          <div class="spinner spinner-primary spinner-lg"></div>
          <div class="mt-5">Loading meeting details...</div>
        </div>
      </div>
      <div v-if="selectedMeeting" class="meeting-details">
        <template v-if="!meetingDetailsLoading">
          <!-- Overall Intent Section -->
          <div
            class="mb-8"
            v-if="
              selectedMeeting.persona_analysis?.length &&
              selectedMeeting.persona_analysis[0]?.overall_intent
            "
          >
            <h5 class="font-weight-bold mb-4">Overall Intent</h5>
            <div class="card card-custom card-stretch gutter-b">
              <div class="card-body">
                <!-- Purpose -->
                <div class="mb-7">
                  <h6 class="font-weight-bold text-dark mb-3">Purpose</h6>
                  <p class="text-dark-75">
                    {{
                      selectedMeeting.persona_analysis[0].overall_intent
                        .purpose || "No purpose specified"
                    }}
                  </p>
                </div>

                <!-- Key Discussion Points -->
                <div class="mb-7">
                  <h6 class="font-weight-bold text-dark mb-3">
                    Key Discussion Points
                  </h6>
                  <div class="d-flex flex-wrap">
                    <template
                      v-if="
                        selectedMeeting.persona_analysis[0].overall_intent
                          .key_discussion_points?.length
                      "
                    >
                      <div
                        v-for="(point, index) in selectedMeeting
                          .persona_analysis[0].overall_intent
                          .key_discussion_points"
                        :key="index"
                        class="bg-light-info rounded py-2 px-3 mr-2 mb-2"
                      >
                        {{ point }}
                      </div>
                    </template>
                    <div v-else class="text-muted">
                      No discussion points available
                    </div>
                  </div>
                </div>

                <!-- Themes -->
                <div class="mb-0">
                  <h6 class="font-weight-bold text-dark mb-3">Themes</h6>
                  <div class="d-flex flex-wrap">
                    <template
                      v-if="
                        selectedMeeting.persona_analysis[0].overall_intent
                          .themes?.length
                      "
                    >
                      <div
                        v-for="(theme, index) in selectedMeeting
                          .persona_analysis[0].overall_intent.themes"
                        :key="index"
                        class="badge badge-light-primary rounded-pill mr-2 mb-2 px-3 py-2"
                      >
                        {{ theme }}
                      </div>
                    </template>
                    <div v-else class="text-muted">No themes available</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="alert alert-info mb-8">
            No persona analysis data available for this interview.
          </div>

          <!-- Meeting Information -->
          <div class="mb-8">
            <h5 class="font-weight-bold mb-4">Meeting Information</h5>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="text-muted font-size-sm">Duration</label>
                  <div class="font-weight-bolder">
                    {{ selectedMeeting.duration || 0 }} minutes
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="text-muted font-size-sm">Meeting Link</label>
                  <div class="font-weight-bolder">
                    <a
                      v-if="selectedMeeting.interview_request?.meeting_link"
                      :href="selectedMeeting.interview_request.meeting_link"
                      target="_blank"
                      class="text-primary"
                    >
                      Join Meeting
                    </a>
                    <span v-else class="text-muted"
                      >No meeting link available</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="text-muted font-size-sm">Start Time</label>
                  <div class="font-weight-bolder">
                    {{
                      formatDateTime(
                        selectedMeeting.interview_request?.meeting_start_time
                      )
                    }} (UTC)
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="text-muted font-size-sm">End Time</label>
                  <div class="font-weight-bolder">
                    {{
                      formatDateTime(
                        selectedMeeting.interview_request?.meeting_end_time
                      )
                    }} (UTC)
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Velents Recording information -->
          <div class="mb-8 d-flex flex-column justify-content-center">
            <h5 class="font-weight-bold mb-3">Velents Meeting Recording</h5>
            <div class="font-weight-bolder" v-if="selectedMeeting?.record_url">
              <a
                :href="selectedMeeting.record_url"
                target="_blank"
                class="text-primary"
                style="width: max-content"
              >
                Download Recording
              </a>
            </div>
            <span v-else class="text-muted">No recording link available</span>
          </div>
          <!-- Squadio Recording information -->
          <div class="mb-8">
            <h5 class="font-weight-bold mb-5">Squadio Meeting Recordings</h5>
            <v-card>
              <v-card-text class="pt-4">
                <v-sheet
                  v-if="
                    !selectedMeeting?.google_meet_recordings ||
                    selectedMeeting?.google_meet_recordings.length === 0
                  "
                  class="text-center py-8"
                >
                  <v-icon size="64" color="grey lighten-1"
                    >mdi-video-off</v-icon
                  >
                  <div class="text-h6 grey--text text--darken-1 mt-3">
                    No recordings available
                  </div>
                  <div class="grey--text">
                    Recordings will appear here when available
                  </div>
                </v-sheet>
                <v-sheet
                  v-else
                  class="recording-list overflow-y-auto"
                  max-height="300px"
                >
                  <v-list>
                    <v-list-item
                      v-for="(
                        recording, index
                      ) in selectedMeeting?.google_meet_recordings"
                      :key="index"
                      class="mb-2"
                    >
                      <v-card width="100%" outlined>
                        <v-card-text class="pa-3">
                          <v-row align="center" no-gutters>
                            <v-col cols="auto" class="mr-3">
                              <v-avatar
                                color="primary lighten-2"
                                size="40"
                                class="white--text"
                              >
                                <v-icon>mdi-video</v-icon>
                              </v-avatar>
                            </v-col>
                            <v-col>
                              <div>
                                <div class="subtitle-1 font-weight-medium">
                                  Recording {{ index + 1 }}
                                </div>
                                <div class="caption grey--text text--darken-1">
                                  {{ formatDate(recording.start_time) }}
                                </div>
                              </div>
                            </v-col>
                            <v-col cols="auto" class="text-right">
                              <div
                                class="caption grey--text text--darken-1 mb-1"
                              >
                                Duration: {{ recording.duration_text }}
                              </div>
                              <v-btn
                                small
                                outlined
                                color="primary"
                                :href="recording.file_url"
                                target="_blank"
                              >
                                <v-icon left small>mdi-open-in-new</v-icon>
                                Open
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-list-item>
                  </v-list>
                </v-sheet>
              </v-card-text>
            </v-card>
          </div>
          <!-- Selected talent information -->
          <div class="mb-8 d-flex flex-column justify-content-center">
            <h5 class="font-weight-bold mb-3">Client Profile</h5>
            <div class="font-weight-bolder" v-if="selectedMeeting?.client_id">
              <router-link
                :to="`/dashboard/client/${selectedMeeting?.client_id}/project/${selectedMeeting?.client_project_id}/selected-talents`"
                target="_blank"
                class="text-primary"
                style="width: max-content"
              >
                Go to Client Profile
              </router-link>
            </div>
            <span v-else class="text-muted">No client profile available</span>
          </div>

          <!-- Participants Overview -->
          <div class="mb-8" v-if="combinedPersonaAnalysis">
            <h5 class="font-weight-bold mb-4">Overview</h5>
            <div class="card card-custom">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="text-muted font-size-sm"
                        >Overall Purpose</label
                      >
                      <div class="font-weight-bolder">
                        {{ combinedPersonaAnalysis.overall_intent.purpose }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="text-muted font-size-sm">All Themes</label>
                      <div class="d-flex flex-wrap">
                        <template
                          v-if="
                            combinedPersonaAnalysis.overall_intent.themes.length
                          "
                        >
                          <div
                            v-for="(theme, index) in combinedPersonaAnalysis
                              .overall_intent.themes"
                            :key="index"
                            class="badge badge-light-primary rounded-pill mr-2 mb-2 px-3 py-2"
                          >
                            {{ theme }}
                          </div>
                        </template>
                        <div v-else class="text-muted">No themes available</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="mb-3">
                      <label class="text-muted font-size-sm"
                        >All Discussion Points</label
                      >
                      <ul class="list-unstyled mb-0">
                        <li
                          v-for="(point, index) in combinedPersonaAnalysis
                            .overall_intent.key_discussion_points"
                          :key="index"
                          class="mb-1"
                        >
                          <i class="flaticon2-check-mark text-success mr-2"></i>
                          {{ point }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="separator separator-dashed my-5"></div>
                <h6 class="font-weight-bold mb-4">All Attendees</h6>
                <div class="row">
                  <div
                    v-for="(
                      participant, index
                    ) in combinedPersonaAnalysis.participants"
                    :key="index"
                    class="col-md-6 mb-4"
                  >
                    <div class="card card-custom card-stretch">
                      <div class="card-body">
                        <div class="d-flex align-items-center mb-3">
                          <div class="symbol symbol-50 symbol-light mr-4">
                            <span class="symbol-label font-size-h5">
                              {{ participant.name.charAt(0) }}
                            </span>
                          </div>
                          <div>
                            <h6 class="font-weight-bold mb-1">
                              {{ participant.name }}
                            </h6>
                            <span class="text-muted">{{
                              participant.role
                            }}</span>
                          </div>
                        </div>
                        <div class="mb-3">
                          <label class="text-muted font-size-sm">Intent</label>
                          <div class="font-weight-bolder">
                            {{ participant.intent }}
                          </div>
                        </div>
                        <div class="mb-3">
                          <label class="text-muted font-size-sm"
                            >Key Themes</label
                          >
                          <div class="d-flex flex-wrap">
                            <div
                              v-for="(theme, tIndex) in participant.key_themes"
                              :key="tIndex"
                              class="badge badge-light-info rounded-pill mr-2 mb-2 px-3 py-2"
                            >
                              {{ theme }}
                            </div>
                          </div>
                        </div>
                        <div>
                          <label class="text-muted font-size-sm">Tone</label>
                          <div class="font-weight-bolder">
                            {{ participant.tone }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Transcription -->
          <div class="mb-8">
            <h5 class="font-weight-bold mb-4">Transcription</h5>
            <div class="bg-light p-4 rounded transcription-container">
              <template
                v-if="
                  selectedMeeting.conversation &&
                  selectedMeeting.conversation.length > 0
                "
              >
                <div class="conversation-wrapper">
                  <v-card flat class="conversation-card">
                    <v-card-text class="pa-0">
                      <div class="conversation-messages">
                        <div
                          v-for="(
                            speakerObject, index
                          ) in selectedMeeting.conversation"
                          :key="index"
                          class="message-item d-flex mb-3"
                        >
                          <div
                            :class="[
                              'speaker-badge mr-3 px-2 py-1 rounded text-caption font-weight-medium',
                              speakerObject.speaker_id === 'speaker_0'
                                ? 'speaker-0'
                                : 'speaker-1',
                            ]"
                          >
                            {{
                              speakerObject.speaker_id === "speaker_0"
                                ? "Speaker 0"
                                : "Speaker 1"
                            }}
                          </div>
                          <div class="message-text flex-grow-1">
                            {{ speakerObject.text }}
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </template>
              <v-alert v-else text type="info" class="mb-0" outlined>
                No transcription available
              </v-alert>
            </div>
          </div>

          <!-- Created By -->
          <div
            class="mb-8"
            v-if="selectedMeeting.interview_request?.created_by"
          >
            <h5 class="font-weight-bold mb-4">Created By</h5>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="text-muted font-size-sm">Name</label>
                  <div class="font-weight-bolder">
                    {{
                      [
                        selectedMeeting.interview_request.created_by.first_name,
                        selectedMeeting.interview_request.created_by.last_name,
                      ]
                        .filter(Boolean)
                        .join(" ") || "-"
                    }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="text-muted font-size-sm">Email</label>
                  <div class="font-weight-bolder">
                    {{
                      selectedMeeting.interview_request.created_by.email || "-"
                    }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="text-muted font-size-sm">Created At</label>
                  <div class="font-weight-bolder">
                    {{
                      formatDateTime(
                        selectedMeeting.interview_request?.created_at
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div
        v-if="!meetingDetailsLoading && !selectedMeeting"
        class="text-center py-5"
      >
        <div class="text-muted">No meeting details available</div>
      </div>
    </b-modal>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import AIBotResponseFilter from "@/components/ai-bot-response/AIBotResponseFilter.vue";

export default {
  name: "AIBotResponse",
  components: {
    AIBotResponseFilter,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 8,
      showDetailsModal: false,
      showFilter: false,
      query: {},
    };
  },
  computed: {
    ...mapGetters({
      responses: "aiBotResponse/getResponsesData",
      responsesMeta: "aiBotResponse/getResponsesMeta",
      stats: "aiBotResponse/getInterviewStats",
      selectedMeeting: "aiBotResponse/getSelectedMeeting",
      meetingDetailsLoading: "aiBotResponse/getMeetingDetailsLoading",
    }),
    combinedPersonaAnalysis() {
      if (!this.selectedMeeting?.persona_analysis?.length) return null;

      const combined = {
        overall_intent: {
          purpose: "",
          themes: new Set(),
          key_discussion_points: new Set(),
        },
        participants: new Map(),
      };

      // Combine all persona analysis data
      this.selectedMeeting.persona_analysis.forEach((analysis) => {
        // Combine purposes
        if (analysis.overall_intent.purpose) {
          combined.overall_intent.purpose +=
            (combined.overall_intent.purpose ? " " : "") +
            analysis.overall_intent.purpose;
        }

        // Combine themes
        if (analysis.overall_intent.themes) {
          analysis.overall_intent.themes.forEach((theme) =>
            combined.overall_intent.themes.add(theme)
          );
        }

        // Combine key discussion points
        if (analysis.overall_intent.key_discussion_points) {
          analysis.overall_intent.key_discussion_points.forEach((point) =>
            combined.overall_intent.key_discussion_points.add(point)
          );
        }

        // Combine participants
        if (analysis.participants) {
          analysis.participants.forEach((participant) => {
            if (!combined.participants.has(participant.name)) {
              combined.participants.set(participant.name, {
                name: participant.name,
                role: participant.role,
                intent: new Set(),
                key_themes: new Set(),
                tone: new Set(),
              });
            }

            const existingParticipant = combined.participants.get(
              participant.name
            );
            if (participant.intent)
              existingParticipant.intent.add(participant.intent);
            if (participant.key_themes)
              participant.key_themes.forEach((theme) =>
                existingParticipant.key_themes.add(theme)
              );
            if (participant.tone)
              existingParticipant.tone.add(participant.tone);
          });
        }
      });

      // Convert Sets to Arrays and format the data
      return {
        overall_intent: {
          purpose: combined.overall_intent.purpose || "No purpose specified",
          themes: Array.from(combined.overall_intent.themes),
          key_discussion_points: Array.from(
            combined.overall_intent.key_discussion_points
          ),
        },
        participants: Array.from(combined.participants.values()).map(
          (participant) => ({
            name: participant.name,
            role: participant.role,
            intent: Array.from(participant.intent).join(", "),
            key_themes: Array.from(participant.key_themes),
            tone: Array.from(participant.tone).join(", "),
          })
        ),
      };
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Dashboard", route: "/dashboard" },
      { title: "Interviews" },
    ]);
  },
  watch: {
    currentPage() {
      this.handleGettingResponsesData();
    },
  },
  created() {
    this.handleGettingResponsesData();
    this.getInterviewStats();
  },
  methods: {
    ...mapActions({
      getResponsesData: "aiBotResponse/getResponsesData",
      getInterviewStats: "aiBotResponse/getInterviewStats",
      getMeetingDetails: "aiBotResponse/getMeetingDetails",
    }),
    log(message) {
      console.log(message);
    },
    async viewMeeting(meeting) {
      this.showDetailsModal = true;
      try {
        await this.getMeetingDetails(meeting.id);
      } catch (error) {
        console.error("Error fetching meeting details:", error);
      }
    },
    formatDateTime(date) {
      if (!date) return "-";
      return new Date(date).toLocaleString();
    },
    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleDateString();
    },
    formatTimeRange(startTime, endTime) {
      if (!startTime || !endTime) return "-";
      const start = new Date(startTime).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
      const end = new Date(endTime).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
      return `${start} - ${end}`;
    },
    getStatusClass(status) {

      const statusClasses = {
        expired: "light",
        rejected: "dark",
        talent_no_show: "info",
        talent_pending_update: "info",
        talent_pending: "info",
        talent_unavailable: "info",
        scheduled: "primary",
        bot_issue: "danger",
        unknown_no_show: "warning",
        archived: "success",
        completed: "success",
        hired: "success",
        client_no_show: "primary",
        client_pending_update: "primary",
        client_pending: "primary",
      };
      return statusClasses[status] || "primary";
    },
    handleGettingResponsesData() {
      this.getResponsesData({
        page: this.currentPage,
        perPage: this.perPage,
        ...this.query,
      });
    },
    applyFilter(query) {
      this.query = query;
      this.currentPage = 1;
      this.handleGettingResponsesData();
    },
    async handlePageChange(page) {
      this.currentPage = page;
      this.handleGettingResponsesData();
    },
    // parseTranscription(transcription) {
    //   if (!transcription) return [];

    //   const messages = [];
    //   const lines = transcription.split(/[.!?]+/).filter((line) => line.trim());
    //   let currentSpeaker = "interviewer";
    //   let currentText = "";

    //   lines.forEach((line) => {
    //     const trimmedLine = line.trim();

    //     // Check for speaker changes
    //     if (trimmedLine.toLowerCase().includes("you")) {
    //       if (currentText) {
    //         messages.push({
    //           speaker: currentSpeaker,
    //           text: currentText.trim(),
    //         });
    //       }
    //       currentSpeaker = "interviewer";
    //       currentText = trimmedLine;
    //     } else if (trimmedLine.toLowerCase().includes("i")) {
    //       if (currentText) {
    //         messages.push({
    //           speaker: currentSpeaker,
    //           text: currentText.trim(),
    //         });
    //       }
    //       currentSpeaker = "candidate";
    //       currentText = trimmedLine;
    //     } else {
    //       currentText += " " + trimmedLine;
    //     }
    //   });

    //   // Add the last message if there's any remaining text
    //   if (currentText) {
    //     messages.push({
    //       speaker: currentSpeaker,
    //       text: currentText.trim(),
    //     });
    //   }

    //   return messages;
    // },
  },
};
</script>

<style lang="scss">
.ai-bot-response {
  .badge-success {
    background-color: #28a745;
  }
  .badge-light {
    color: #fff;
    background-color: #808080;
  }
}
.text-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.text-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.bg-light-info {
  background-color: #e1f0ff !important;
  color: #3699ff !important;
}

.badge-light-primary {
  color: #3699ff !important;
  background-color: #e1f0ff !important;
  font-weight: 500;
  font-size: 0.9rem;
}

.meeting-details {
  .card-custom {
    border-radius: 0.5rem;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.05);
    border: none;
  }

  .text-dark-75 {
    color: #464e5f !important;
  }

  .bg-light-info {
    font-size: 0.9rem;
    font-weight: 500;
  }

  .bg-light {
    background-color: #f3f6f9 !important;
  }
}

.card-custom {
  border-radius: 0.5rem;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
  border: none;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    
  }

  .card-body {
    position: relative;
    z-index: 2;
  }
}

.symbol {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);

  i {
    font-size: 2rem;
  }
}

.bg-primary {
  background: linear-gradient(135deg, #3699ff 0%, #187de4 100%) !important;
}

.bg-success {
  background: linear-gradient(135deg, #0bb783 0%, #06a275 100%) !important;
}

.bg-warning {
  background: linear-gradient(135deg, #ffa800 0%, #ee9d01 100%) !important;
}

.bg-danger {
  background: linear-gradient(135deg, #f64e60 0%, #ee2d41 100%) !important;
}

.conversation {
  max-width: 800px;
  margin: 0 auto;
  font-size: 1rem;
  line-height: 1.5;

  .message {
    margin-bottom: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .speaker-0 {
      font-weight: 600;
      color: #3699ff;
      font-size: 1.1rem;
    }

    .speaker-1 {
      font-weight: 600;
      color: #0bb783;
      font-size: 1.1rem;
    }

    .text {
      color: #464e5f;
      padding-left: 1rem;
      line-height: 1.6;
      font-size: 1rem;
    }
  }
}

.transcription-container {
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.conversation-wrapper {
  max-height: 400px;
  overflow-y: auto;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #bdbdbd;
    border-radius: 10px;

    &:hover {
      background: #9e9e9e;
    }
  }
}

.conversation-messages {
  padding-right: 8px;
}

.message-item {
  position: relative;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.03);
  }
}

.speaker-badge {
  min-width: 80px;
  text-align: center;
  align-self: flex-start;
}

.speaker-0 {
  background-color: rgba(33, 150, 243, 0.15);
  color: #1976d2;
}

.speaker-1 {
  background-color: rgba(76, 175, 80, 0.15);
  color: #388e3c;
}

.message-text {
  line-height: 1.5;
  word-break: break-word;
}

/* Media query for smaller screens */
@media (max-width: 600px) {
  .conversation-wrapper {
    max-height: 300px;
  }

  .message-item {
    flex-direction: column;
  }

  .speaker-badge {
    margin-bottom: 8px;
    margin-right: 0;
    align-self: flex-start;
  }
}
.recording-list {
  max-height: 350px;
  overflow-y: auto;
}
</style>
